let revealObserver = null;
let cardFlipObserver = null;
let fadeAnimateObserver = null;

// fade-up淡入动画
export function fadeAnimate(threshold = 0.08) {
  // 防止在非浏览器环境执行
  if (typeof window === 'undefined' || !window.IntersectionObserver) return
  if (fadeAnimateObserver) {
    fadeAnimateObserver.disconnect() // 先清除已存在的
  }
  fadeAnimateObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return
      const el = entry.target
      el.classList.add('visible')
      fadeAnimateObserver.unobserve(el)
    })
  }, { threshold, }) // 监听阈值: 默认0.08

  document.querySelectorAll('.fade-up').forEach(el => fadeAnimateObserver.observe(el))

  return fadeAnimateObserver
}

export function destroyFadeAnimate() {
  if (fadeAnimateObserver) {
    fadeAnimateObserver.disconnect()
    fadeAnimateObserver = null
  }
}


// 上浮淡入动画
export function revealAnimate() {
  // 防止在非浏览器环境执行
  if (typeof window === 'undefined' || !window.IntersectionObserver) return;
  if (revealObserver) {
    revealObserver.disconnect() // 先清除已存在的
  }
  revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const siblings = Array.from(entry.target.parentElement.querySelectorAll('.reveal'));
      const idx = siblings.indexOf(entry.target);
      entry.target.style.transitionDelay = (idx * 60) + 'ms';
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
  
  return revealObserver
}

export function destroyRevealAnimate() {
  if (revealObserver) {
    revealObserver.disconnect()
    revealObserver = null
  }
}

// 卡片翻转动画
export function cardFlipAnimate() {
  // 防止在非浏览器环境执行
  if (typeof window === 'undefined' || !window.IntersectionObserver) return;
  if (cardFlipObserver) {
    cardFlipObserver.disconnect() // 先清除已存在的
  }
  const cardInners = document.querySelectorAll('.char-card-inner');
  cardInners.forEach(card => {
    card.style.transform = 'rotateY(180deg)';
    card.style.transition = 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)';
  });

  cardFlipObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const card = entry.target;
      const index = Array.from(cardInners).indexOf(card);
      setTimeout(() => {
        card.style.transform = 'rotateY(0deg)';
      }, index * 150);
      cardFlipObserver.unobserve(card);
    });
  }, { threshold: 0.3 });

  cardInners.forEach(card => cardFlipObserver.observe(card));
  
  return cardFlipObserver
}

export function destroyCardFlipAnimate() {
  if (cardFlipObserver) {
    cardFlipObserver.disconnect()
    cardFlipObserver = null
  }
}